"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ApiResponse = _flowRuntime["default"].tdz(function () {
  return _types.ApiResponse;
});

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(response) {
  switch (response.response.status) {
    case 200:
      return undefined;

    case 404:
      return {
        code: response.response.status,
        message: 'Sorry! We can’t find the form you are looking for.'
      };

    case 500:
      return {
        code: response.response.status,
        message: 'Sorry! Due to lots of people visiting this page, it’s temporarily unavailable.'
      };

    default:
      return response.payload;
  }
};

exports["default"] = _default;